<template>
    <!-- See: `getFullVh()` -->
    <div style="overflow: hidden; height: 0">
        <div id="measure-vh" style="position: fixed; height: 100vh"></div>
    </div>
    <!-- showPopUpOk --><transition name="fade">
    <div v-show="showPopUpOk" class="modal-overlayfrombottomblur" style="z-index: 999;">
      <div class="modal" style="padding-top: 3vh; padding-bottom: 3vh; min-height: 40vh; width: 70%"> 
        <!-- put in table for dev speed need to learn more about flex -->
        <table border=0 width=80%> 
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': this.fontSizeTitle + 'vh', 'line-height': this.fontSizeTitleLineHeight + 'vh', }">                 
              {{ this.popUpMsgTitle }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': this.fontSizePopUpMsg + 'vh', 'line-height': this.fontSizePopUpMsgLineHeight + 'vh', 'padding-top': '1vh', }">                 
              {{ this.popUpMsgBody }}
              </div>
            </td>
          </tr>
          <tr v-show="!this.suppressOk">
            <td style="height: 10vh">
              <div style="padding-top: 2vh"><button class="widebtn" ref="show-popup-ok" style="width: 50%; height: 6vh; " @click="this.doPopUpOk();">Ok</button></div>
            </td>
          </tr>
          
        </table>       
      </div>
    </div>
    </transition>
    <!-- showManagementDashboard --><transition name="fade">
    <div id="topdiv" class="modal-overlay-canscroll" style="width: 100%; ">
        <div class="modal" style="outline:0.0em solid blue; display: table-cell; padding-top: 0vh; padding-bottom: 0vh; height:90vh; background-color:#EDF2F7; box-shadow: 0 0px 0px rgba(0, 0, 0, 0.0);" :style="{ 'height': 98 * this.vhMult + 'vh'}"> 

        <table cellspacing="0" cellpadding="0" width=100% border=0 style="padding-left: 2.5vh; padding-right: 2.5vh; ">
            <tr>
                <td>
                    <table width="100%" border=0 style="height: 6vh">
                        <tr>
                            <td width="20%">
                                <div class=divl><button class="text-only-button cancel" @click="this.goBack()" style="display: block;" :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }"><img class="tulogo" valign=middle style="height: 1.8vh; padding-bottom: 0.3vh" alt="back" src="../assets/chevron.png"> Back</button></div>
                            </td>
                            <td width="60%">
                                Management Dashboard
                            </td>
                            <td width="20%">
                            
                            </td>

                        </tr>
                    </table>
                    
                </td>
            </tr>
            <!-- ManagementChart1 -->
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <div v-if="venueName !== ''"><br>{{ venueName }}</div>
                    <canvas id="ManagementChart1" width="100%" height="100%"></canvas>
                    <div v-if="totalFees !== 0" style="font-size:70%; line-height: 150%">
                    <br>Avg tips /mth: £{{ totalTips }}
                    <br>..where fees paid by client: {{ percentageFeesPaidByClient }}%
                    <br>..where fees deducted from tip: {{ percentageFeesPaidByRecipient }}%
                    <br>Avg fees /mth not paid by clients: £{{ totalFeesPaidByRecipient }}
                    <br>..as % of total tips: {{ recipientPaidAsPercentageOfTips }}%
                    
                    </div>
                    <div v-if="totalFees !== 0" style="font-size:90%; line-height: 150%">
                    <br>Avg monthly fees: £{{ totalFees }}
                    <br>..paid by client: £{{ totalFeesPaidByClient }}
                    <br>Paid by staff: £{{ totalFeesPaidByRecipient }}
                    <br>&nbsp;
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                &nbsp; 
                </td>
            </tr>

            <!-- ManagementChart1a -->
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <div v-if="venueName1a !== ''"><br>{{ venueName1a }}</div>
                    <canvas id="ManagementChart1a" width="100%" height="100%"></canvas>
                    <div v-if="totalFees1a !== 0" style="font-size:70%; line-height: 150%">
                    <br>Avg tips /mth: £{{ totalTips1a }}
                    <br>..where fees paid by client: {{ percentageFeesPaidByClient1a }}%
                    <br>..where fees deducted from tip: {{ percentageFeesPaidByRecipient1a }}%
                    <br>Avg fees /mth not paid by clients: £{{ totalFeesPaidByRecipient1a }}
                    <br>..as % of total tips: {{ recipientPaidAsPercentageOfTips1a }}%

                    
                    </div>
                    <div v-if="totalFees1a !== 0" style="font-size:90%; line-height: 150%">
                    <br>Avg monthly fees: £{{ totalFees1a }}
                    <br>..paid by client: £{{ totalFeesPaidByClient1a }}
                    <br>Paid by staff: £{{ totalFeesPaidByRecipient1a }}
                    </div>
                    <br>&nbsp;
                </td>
            </tr>
            <tr>
                <td>
                    &nbsp; 
                </td>
            </tr>

            <!-- ManagementChart1b -->
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <div v-if="venueName1b !== ''"><br>{{ venueName1b }}</div>
                    <canvas id="ManagementChart1b" width="100%" height="100%"></canvas>
                    <div v-if="totalFees1b !== 0" style="font-size:70%; line-height: 150%">
                    <br>Avg tips /mth: £{{ totalTips1b }}
                    <br>..where fees paid by client: {{ percentageFeesPaidByClient1b }}%
                    <br>..where fees deducted from tip: {{ percentageFeesPaidByRecipient1b }}%
                    <br>Avg fees /mth not paid by clients: £{{ totalFeesPaidByRecipient1b }}
                    <br>..as % of total tips: {{ recipientPaidAsPercentageOfTips1b }}%
                    </div>
                    <div v-if="totalFees1b !== 0" style="font-size:90%; line-height: 150%">
                    <br>Avg monthly fees: £{{ totalFees1b }}
                    <br>..paid by client: £{{ totalFeesPaidByClient1b }}
                    <br>Paid by staff: £{{ totalFeesPaidByRecipient1b }}
                    </div>
                     <br />&nbsp;
                </td>
            </tr>
            <tr>
                <td>
                    <br />&nbsp;
                    
                </td>
            </tr>

            <!-- ManagementChart1c (placeholder) -->
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <div v-if="venueName1c !== ''"><br>{{ venueName1c }}</div>
                    <canvas id="ManagementChart1c" width="100%" height="100%"></canvas>
                    <div v-if="totalFees1c !== 0" style="font-size:70%; line-height: 150%">
                    <br>Avg tips /mth: £{{ totalTips1c }}
                    <br>..where fees paid by client: {{ percentageFeesPaidByClient1c }}%
                    <br>..where fees deducted from tip: {{ percentageFeesPaidByRecipient1c }}%
                    <br>Avg fees /mth not paid by clients: £{{ totalFeesPaidByRecipient1c }}
                    <br>..as % of total tips: {{ recipientPaidAsPercentageOfTips1c }}%
                    </div>
                    <div v-if="totalFees1c !== 0" style="font-size:90%; line-height: 150%">
                    <br>Avg monthly fees: £{{ totalFees1c }}
                    <br>..paid by client: £{{ totalFeesPaidByClient1c }}
                    <br>Paid by staff: £{{ totalFeesPaidByRecipient1c }}
                    </div>
                    <br />&nbsp;
                </td>
            </tr>
            <tr>
                <td>
                    <br>&nbsp;
                </td>
            </tr>

            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <canvas id="ManagementChart2" width=100% height=100%></canvas>
                </td>
            </tr>
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <canvas id="ManagementChart3" width=100% height=100%></canvas>
                </td>
            </tr>
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <canvas id="ManagementChart4" width=100% height=100%></canvas>
                </td>
            </tr>
             <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <canvas id="ManagementChart5" width=100% height=100%></canvas>
                </td>
            </tr>
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <canvas id="ManagementChart6" width=100% height=100%></canvas>
                </td>
            </tr>
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <canvas id="ManagementChart7" width=100% height=100%></canvas>
                </td>
            </tr>
            <tr>
                <td style="height:30vh; background-color:#FFFFFF; border-radius: 10px">
                    <canvas id="ManagementChart8" width=100% height=100%></canvas>
                </td>
            </tr>

        </table> 
        </div>
        
      </div>
      </transition>
    
</template>

<script>

const Parse = require('parse/node');

import shared from '../shared.js';


export default {
    name: 'AccountManagementDashboard',
    inject: ['globalPushForwardInterval', 'devEnv', 'appId', 'appJSKey'] ,
    props:  {
        userData: shared.userDataStruct(),
    },
    data () {
        return {
            fontSizeNormal: 3.0, // vh
            fontSizeNormalInPXToUse: "",
            fontSizeNormalLineHeight: 3.6,// vh
            fontSizeNormalInPXLineHeightToUse: "",
            fontSizeRecord: 3.0, // vh
            fontSizeRecordInPXToUse: "",
            fontSizeRecordLineHeight: 3.0,// vh
            fontSizeRecordInPXLineHeightToUse: "",
            showPopUpTwoOptions: false,
            PopUpTwoOptionsTitle: "",
            PopUpTwoOptionsMessage: "",  
            option1ButtonText: "",
            option2ButtonText: "",
            showPopUpOk: false,
            popUpMsgTitle: "",
            popUpMsgBody: "",
            suppressOk: false,
            vhMult: 1,


             // For ManagementChart1 (all)
            venueName: "",
            totalFeesPaidByClient: 0,
            totalFeesPaidByRecipient: 0,
            totalFees: 0,
            totalTips: 0,
            percentageFeesPaidByClient: 0,
            percentageFeesPaidByRecipient: 0,
            recipientPaidAsPercentageOfTips: 0,

            // For ManagementChart1a (addFeesTicked === true)
            venueName1a: "",
            totalFeesPaidByClient1a: 0,
            totalFeesPaidByRecipient1a: 0,
            totalFees1a: 0,
            totalTips1a: 0,
            percentageFeesPaidByClient1a: 0,
            percentageFeesPaidByRecipient1a: 0,
            recipientPaidAsPercentageOfTips1a: 0,

            // For ManagementChart1b (addFeesTicked !== true && feesAtUserOption !== false)
            venueName1b: "",
            totalFeesPaidByClient1b: 0,
            totalFeesPaidByRecipient1b: 0,
            totalFees1b: 0,
            totalTips1b: 0,
            percentageFeesPaidByClient1b: 0,
            percentageFeesPaidByRecipient1b: 0,
            recipientPaidAsPercentageOfTips1b: 0,

            // For ManagementChart1c (reserved for future scenario)
            venueName1c: "",
            totalFeesPaidByClient1c: 0,
            totalFeesPaidByRecipient1c: 0,
            totalFees1c: 0,
            totalTips1c: 0,
            percentageFeesPaidByClient1c: 0,
            percentageFeesPaidByRecipient1c: 0,
            recipientPaidAsPercentageOfTips1c: 0

            
        }
    },
    methods: {
        doFontSizeComputed () {
            this.fontSizeNormalInPXToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormal, 16);
            this.fontSizeNormalInPXLineHeightToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormalLineHeight, 20);
            this.fontSizeRecordInPXToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeRecord, 16);
            this.fontSizeRecordInPXLineHeightToUse = shared.convertVHSizeToMaxPixelsSize(this.fontSizeRecordLineHeight, 17);
        },
        
        goBack(){
            this.userData.nextScreen = "showAccountScreen";
            // console.log("this.userData::: " + JSON.stringify(this.userData, null, 2));
            this.$emit("next-action", this.userData);
        },

        doPopUpOk(){
            this.showPopUpOk = false;
        },
        doShowAccountScreen(){
            // console.log("leaving AccountManagementDashboard screen");
            this.userData = this.user;
            this.userData.nextScreen = "showAccountScreen"
            this.$emit("next-action", this.userData);
        },
        /**
         * Fetches and processes fee payment statistics from the backend for four scenarios:
         *  - All web payments (`ManagementChart1`)
         *  - Venues with fees pre-ticked (`ManagementChart1a`)
         *  - Venues where fees are not pre-ticked but user option is enabled (`ManagementChart1b`)
         *  - Venues whose pool name starts with "HARI’s" (`ManagementChart1c`)
         *
         * For each scenario, the method:
         * - Populates a corresponding chart with weekly % of fees paid by tipper
         * - Computes monthly averages based on data from completed months only
         * - Assigns ancillary values (monthly fees, tips, and percentage breakdowns) to Vue `data()` properties
         *
         * Data fields populated (suffix per scenario: "", "1a", "1b", "1c"):
         * @property {string} venueName        - Label for the scenario
         * @property {number} totalFees        - Avg total fees per month
         * @property {number} totalTips        - Avg total tips per month
         * @property {number} totalFeesPaidByClient - Avg monthly fees paid by tipper
         * @property {number} totalFeesPaidByRecipient - Avg monthly fees deducted from tip
         * @property {number} percentageFeesPaidByClient - % of total fees paid by tipper
         * @property {number} percentageFeesPaidByRecipient - % of total fees deducted from tip
         * @property {number} recipientPaidAsPercentageOfTips - % of tips lost to platform fees
         *
         * Also calls `populateChart(chartId, values, labels, label)` for each chart scenario.
         */
        async getPercentagePayingFeesObject() {
            console.log("doing getPercentagePayingFeesObject");

            const result = await Parse.Cloud.run("getPercentagePayingFees", undefined);
            const { all, feesTicked, userOption, HARI } = result;

            const applyResultToState = (dataPrefix, chartPrefix, data) => {
                const months = data.weeksCount / 4.345;

                this[`venueName${dataPrefix}`] = data.venueName;
                this[`totalFeesPaidByClient${dataPrefix}`] = +(data.fullMonthTotals.totalFeesPaidByClient / months).toFixed(0);
                this[`totalFeesPaidByRecipient${dataPrefix}`] = +(data.fullMonthTotals.totalFeesPaidByRecipient / months).toFixed(0);
                this[`totalFees${dataPrefix}`] = +(data.fullMonthTotals.totalFees / months).toFixed(0);
                this[`totalTips${dataPrefix}`] = +(data.fullMonthTotals.totalTips / months).toFixed(0);
                this[`percentageFeesPaidByClient${dataPrefix}`] = data.percentageFeesPaidByClient;
                this[`percentageFeesPaidByRecipient${dataPrefix}`] = data.percentageFeesPaidByRecipient;

                const tips = this[`totalTips${dataPrefix}`];
                const recipientFees = this[`totalFeesPaidByRecipient${dataPrefix}`];
                this[`recipientPaidAsPercentageOfTips${dataPrefix}`] = tips > 0
                    ? +(recipientFees / tips * 100).toFixed(1)
                    : 0;

                this.populateChart(`ManagementChart${chartPrefix}`, data.weekDatePerCentValueArray, data.weekDateArray, "% paid fees");
            };

            // Apply each result set with matching variable prefixes
            applyResultToState("", "1", all);           // For ManagementChart1
            applyResultToState("1a", "1a", feesTicked);  // For ManagementChart1a
            applyResultToState("1b", "1b", userOption);  // For ManagementChart1b
            applyResultToState("1c", "1c", HARI);        // For ManagementChart1c
        },
        async getPercentageSettingDisplaynameObject(){
            const percentageSettingDisplaynameObject = await Parse.Cloud.run("getPercentageSettingDisplayname", undefined);   
            this.showPopUpOk = false;
            this.suppressOk = false;
            // console.log("percentageSettingDisplaynameObject: " + JSON.stringify(percentageSettingDisplaynameObject, null, 2));
            this.populateChart('ManagementChart2', percentageSettingDisplaynameObject.weekDatePerCentValueArray, percentageSettingDisplaynameObject.weekDateArray, "% set Displayname");
        },
        async getHasSetEmailObject(){
            // console.log("calling getHasSetEmailObject");
            const hasSetEmailObject = await Parse.Cloud.run("getHasSetEmailObject", undefined);   
            // console.log("returned getHasSetEmailObject");
            this.showPopUpOk = false;
            this.suppressOk = false;
            // console.log("hasSetEmailObject: " + JSON.stringify(hasSetEmailObject, null, 2));
            this.populateChart('ManagementChart3', hasSetEmailObject.weekDatePerCentValueArray, hasSetEmailObject.weekDateArray, "% set email");
        },
        async getHasSetPasswordObject(){
            // console.log("calling getHasSetPasswordObject");
            const hasSetPasswordObject = await Parse.Cloud.run("getHasSetPasswordObject", undefined);   
            // console.log("returned getHasSetPasswordObject");
            this.showPopUpOk = false;
            this.suppressOk = false;
            // console.log("getHasSetPasswordObject: " + JSON.stringify(hasSetPasswordObject, null, 2));
            this.populateChart('ManagementChart4', hasSetPasswordObject.weekDatePerCentValueArray, hasSetPasswordObject.weekDateArray, "% set password");
        },
        async getPercentageCancelsObject(){
            // console.log("calling getPercentageCancelsObject");
            const percentageCancelsObject = await Parse.Cloud.run("getPercentageCancelsObject", undefined);   
            // console.log("returned getPercentageCancelsObject");
            // console.log("getPercentageCancelsObject:\n" + JSON.stringify(percentageCancelsObject, null, 2));
            this.showPopUpOk = false;
            this.suppressOk = false;
            // console.log("getPercentageCancelsObject: " + JSON.stringify(percentageCancelsObject, null, 2));
            this.populateChart('ManagementChart5', percentageCancelsObject.weekDatePerCentValueArray, percentageCancelsObject.weekDateArray, "% cancelled");
        },
        async getWeeklyTippedWithoutScanningPercentages(){
            // console.log("calling getPercentageNativePaymentsObject");
            const getWeeklyTippedWithoutScanningPercentagesObject = await Parse.Cloud.run("getWeeklyTippedWithoutScanningPercentages", undefined);   
            console.log("returned getWeeklyTippedWithoutScanningPercentages");
            console.log("getWeeklyTippedWithoutScanningPercentages:\n" + JSON.stringify(getWeeklyTippedWithoutScanningPercentagesObject, null, 2));
            this.showPopUpOk = false;
            this.suppressOk = false;
            this.populateChart('ManagementChart6', getWeeklyTippedWithoutScanningPercentagesObject.weekDatePerCentValueArray, getWeeklyTippedWithoutScanningPercentagesObject.weekDateArray, "% tipped without scanning tips");
        },
        populateChart(chartName, chartData, weekDateArray, legendTitle){
             // const chartData = this.userData.weekTipsArray;
            // const chartData = managementData.percentagePayingFeesObject.weekDatePerCentValueArray;
            // /console.log("chartData: " + chartData);
            const ctx = document.getElementById(chartName);
            var cleanedWeekDateArray = [];
            for (let dateStr of weekDateArray){
                dateStr = dateStr.replace("/2022", "");
                cleanedWeekDateArray.push(dateStr);
            }

            shared.makeChart(
                ctx, 
                chartData, 
                0, 
                "%",
                cleanedWeekDateArray,
                chartName,
                legendTitle,
            );  
        },
    },
    async created(){

        // console.log("creating AccountManagementDashboard");
        Parse.serverURL = 'https://parseapi.back4app.com/'; Parse.initialize(this.appId, this.appJSKey); (this.appId, this.appJSKey);
                
    },
    async mounted(){
        // console.log("mounting AccountManagementDashboard");

        this.doFontSizeComputed();
        this.vhMult = shared.setScreenHeightMultiplier();

        this.popUpMsgTitle = "Just coming...";
        this.popUpMsgBody = "getting the data";
        this.suppressOk = true;
        this.showPopUpOk = true;
        
        // const managementData = await Parse.Cloud.run("getManagementDash", params);     
        // alert("Management data: " + JSON.stringify(managementData.percentagePayingFeesObject, null, 2));

        // not asyncs they come when they come 
        this.getPercentagePayingFeesObject();
        // this.showPopUpOk = false;
        
        
        
        
        this.getPercentageSettingDisplaynameObject();
        this.getHasSetEmailObject();
        this.getHasSetPasswordObject();
        this.getPercentageCancelsObject();
        this.getWeeklyTippedWithoutScanningPercentages();
       
        // const chartData2 = managementData.percentageSettingDisplaynameObject.weekDatePerCentValueArray;
        // const ctx2 = document.getElementById('ManagementChart2');
        // var cleanedWeekDateArray = [];
        // for (const dateStr of managementData.percentageSettingDisplaynameObject.weekDateArray){
        //     dateStr = dateStr.replace("/2022", "");
        //     cleanedWeekDateArray.push(dateStr);
        // }
        // shared.makeChart(
        //     ctx2, 
        //     chartData2, 
        //     0, 
        //     "%",
        //     cleanedWeekDateArray,
        //     "ManagementChart2",
        //     "% set Displayname",
        // );   
        // const chartData3 = managementData.hasSetEmailObject.weekDatePerCentValueArray;
        // const ctx3 = document.getElementById('ManagementChart3');
        // var cleanedWeekDateArray = [];
        // for (const dateStr of managementData.hasSetEmailObject.weekDateArray){
        //     dateStr = dateStr.replace("/2022", "");
        //     cleanedWeekDateArray.push(dateStr);
        // }
        // shared.makeChart(
        //     ctx3, 
        //     chartData3, 
        //     0, 
        //     "%",
        //     cleanedWeekDateArray,
        //     "ManagementChart3",
        //     "% set Displayname",
        // );  
        // const chartData4 = managementData.hasSetPasswordObject.weekDatePerCentValueArray;
        // const ctx4 = document.getElementById('ManagementChart4');
        // var cleanedWeekDateArray = [];
        // for (const dateStr of managementData.hasSetPasswordObject.weekDateArray){
        //     dateStr = dateStr.replace("/2022", "");
        //     cleanedWeekDateArray.push(dateStr);
        // }
        // shared.makeChart(
        //     ctx4, 
        //     chartData4, 
        //     0, 
        //     "%",
        //     cleanedWeekDateArray,
        //     "ManagementChart4",
        //     "% set Displayname",
        // );        
    }
}
</script>

``